<template>
  <div class="wrap">
    <div class="home">
      <div id="container"></div>
      <div v-if="showMask" class="model" @click="showMask=false"></div>
      <div v-if="showTimePicker" class="model" @click="showTimePicker=false"></div>
      <div class="goback" @click="goback()" v-show="carSelection">
        <img src="../../assets/backIcon.png" alt="返回">
      </div>
      <transition name="slide-fade">
        <userInfo :channelTypeTitle="channelTypeTitle" v-if="showMask" @getpush="getpush"/>
      </transition>
      <transition name="pull-up">
        <CarSelection ref="child" v-show="carSelection" @isLogin="isLogin(3)" :carSelectionVisible="carSelection"/>
      </transition>
      <div id="shadowBox"></div>
      <div class="main" v-show="!carSelection" id="main">
        <div class="userInfo positionLeft" @click="isLogin(0)">
          <img
            class="img"
            src="../../assets/my.png"
            alt="个人中心"
          />
        </div>
        <div class="positionRight userInfo" id="pantoBtn" @click="positionRight()">
          <img
            class="img"
            src="../../assets/position.png"
            alt="定位点"
          />
        </div>
        <ul class="nav">
          <li class="li-tab" v-for="(item, index) in tabsParam"
          @click="activeTabs(index)"
          :class="{active:index===nowIndex}" :key="index">{{item}}</li>
        </ul>
        <div class="content">
          <div class="addres" @click="isLogin(1)">
            <span class="arrImg"><img src="../../assets/Oval@2x.png" alt=""/></span>
            <span class="goAddres" v-if="child.addresName.name">{{child.addresName.name}}</span>
            <span style="color: #999999;font-size: 15px;" class="goAddres" v-else>请选择出发地</span>
            <!-- <input
              placeholder="请选择出发地"
              type="text"
              v-model="child.addresName.name"
              class="goAddres"
            /> -->
          </div>
          <div class="addres">
            <span class="arrImg"
              ><img src="../../assets/Oval Copy@2x.png" alt=""
            /></span>
            <span class="goAddres" @click="isLogin(2)" v-if="child.backAddresname.name">{{child.backAddresname.name}}</span>
            <span @click="isLogin(2)" style="color: #999999;font-size: 15px;" class="goAddres" v-else>请选择目的地</span>
            <!-- <input
              @click="isLogin(2)"
              placeholder="请选择目的地"
              type="text"
              v-model="child.backAddresname.name"
              class="goAddres"
              style="border: none"
            /> -->
            <div class="tag" v-show="deleteTag && history.address">
              <span @click="clickTag()">
                去: {{history.address}}
              </span>
              <div class="img" @click="clickDeleteTag()">
                <img src="../../assets/delete.png"  alt="删除"/>
              </div>
            </div>
          </div>
          <van-row class="ridingInfo">
            <div class="styleA">
              <van-col span="11">
                <div class="titleImg">
                  <img class="timemsg" src="../../assets/time.png" alt="乘车时间" />
                  <span v-if="nowIndex===0" style="color:#333;font-weight:bold;">{{child.selectDate}}</span>
                  <span v-else @click="isLogin(3)">{{child.selectDate}}</span>
                </div>
              </van-col>
            </div>
            <div>
              <van-col class="center-line" span="2">|</van-col>
            </div>
            <div @click="isLogin(4)" class="styleA">
              <van-col span="11">
                <div class="titleImg">
                  <img class="timemsg" src="../../assets/peple.png" alt="乘车人" />
                  <span>{{riderInfo.name}}</span>
                </div>
              </van-col>
            </div>
          </van-row>
        </div>
        <div class="right-off" @click="rightOff()">确定</div>
      </div>
    </div>
    <Time v-if="showTimePicker" @nowTime="nowTime"></Time>
    <!--有订单弹窗-->
    <transition name="fadesd" mode="out-in">
      <orderWindows
        v-if="DialogVisible"
        :length="orderlength"
        :orderId="orderId"
        @ievent="ievent"
      ></orderWindows>
    </transition>
    <Loading :show="show"/>
  </div>
</template>
<script>
import Vue from 'vue';
import AMap from "AMap";
import EventSource from "eventsource";
import orderWindows from "../ReceptionStation/model/orderWindows";
import {
  Row,Col,Icon,Popup,DatetimePicker,Toast
} from "vant";
Vue.use(Row).use(Col).use(Icon).use(Popup).use(DatetimePicker).use(Toast);
import {
  __getLocalItem,
  __setLocalItem,
  __setItem,
  __getItem,
  urlParse,
  __isWeChat,
  _getobj,
  __removeItem
} from "@/utils/index";
import userInfo from './components/userInfo.vue'; // 个人中心
import CarSelection from './components/carSelection.vue'; // 车型选择
import Time from './components/time.vue'; // 时间组件
import Loading from '../base/loading/loading';
// import { Touch } from "./index.js";

export default {
  name: "home",
  data: () => ({
    deleteTag: true,
    tabsParam:['现在','预约用车'],
    nowIndex: Number(__getItem('nowIndex')) || 0,
    showMask: false,
    child: {
      selectDate: Number(__getItem('nowIndex')) === 1 ? __getItem('getNewTime') ? __getItem('getNewTime') :'选择时间' : '现在出发', // 出发时间
      addresName: {
        name: "",
        lat: "",
        lng: "",
        depAddress: "", // 出发地详细地址
      }, // 出发地
      backAddresname: {
        name: "",
        lat: "",
        lng: "",
        arrAddress: "", // 目的地详细地址
      } // 目的地
    },
    history: {
      address: "",
      detDdress: "",
      lat: "",
      lng: "",
    }, // 常用历史记录位置
    channelTypeTitle: true, // true显示商旅邦专车，false显示南站疏解专车
    carSelection: false,
    city: '',
    showTimePicker: false,
    riderInfo: {
      name: __getLocalItem("currentUseCarUser")? JSON.parse(__getLocalItem("currentUseCarUser")).name : '乘车人',
      phone: __getLocalItem("currentUseCarUser")? JSON.parse(__getLocalItem("currentUseCarUser")).phone : '',
    }, // 乘车人信息
    eventSource: null,
    orderId: "", // 正在执行的订单号
    orderlength: 0, // 支付订单的长度
    DialogVisible: false, // 订单弹窗
    show: false,
  }),
  // 监听数据变化 watch监听数据的变化只能监视对象中发生了变化，但是不能监听到对象中是哪个值发生了变化，
  // 如果想要知道child中的某个子元素发生了变化可以利用 computed计算属性
  watch: {
    'child.backAddresname': {
      // 深度监听，可监听到对象、数组的变化
      handler:function(oldVal, curVal) {
        if (!this.isNeedLogin() && !this.isNeedName()) {
          // 监听事件判断出发地、目的地、出发时间都不为空的前提下 调取生成价格接口
          if(Object.keys(oldVal).length === 0) {
            this.deleteTag = true
          } else {
            this.deleteTag = false
          }
          if (oldVal) {
            if (Object.keys(oldVal).length === 0) return
            this.drivingMap();
          }
        }
      },
    }
  },
  components: {
    userInfo,
    CarSelection,
    Time,
    orderWindows,
    Loading,
  },
  mounted() {
    // this.$store.commit('scroll', true);
    // Touch({
    //   contEl:document.getElementById("shadowBox"),   //背景灰色浮层
    //   shadowEl:document.getElementById("main"),    //内容块
    //   top:0.4,   //内容块停留的最高处 (取值范围：0.1-1,默认0.1)
    //   bottom:0.75,   //内容块停留的最低处 (取值范围：0.1-1,默认0.9)
    //   opacity:0.5,   //背景灰色浮层的最高透明值 (取值范围：0.1-1,默认0.5)
    //   duration:0.3   //松手时候下滑或上滑动画的持续时间 (单位：秒,默认0.3)
    // });

    /**
     * 南站疏解预约出行标识trip，默认登录
     * 默认登录的三个条件
     * 1、username && name
     * 2、openID
     * 3、username && name && openID
     */

    // urlChannel = train 铁路旅行入口标识
    // urlType = trip 南站疏解入口标识

    const urlObj = urlParse(window.location.href);
    const openID = __getItem('urlOpenID') ? __getItem('urlOpenID') : __getLocalItem("openId");
    if(__getItem('urlChannel') === "train" && __getItem('urlOpenID') ) {
      this.channelTypeTitle = false;
      // 铁路旅行单点登录
      if(__getItem('urlChannel') === "train" && __getItem('urlOpenID')) {
        // 单点登录
        this.defaultLogin("train",urlObj,openID);
      } else {
        this.noLoginToLoginPage("train");
      }
      // 南站疏解单点登录
    } else if (urlObj && __getItem('urlType') === "trip" && !urlObj.channel && __getItem('urlOpenID')) {
      this.channelTypeTitle = false;
      if((urlObj.username && urlObj.name) || __getItem('urlOpenID')) {
        // 单点登录
        this.defaultLogin("trip", urlObj,openID);
      } else {
        this.noLoginToLoginPage("trip");
      }
    }
    // 获取用户当前订单数量，有用户登录提示
    if (
      !this.isNeedLogin() &&
      !this.isNeedName() &&
      !__getItem("DialogVisible")
    ) {
      if (this.$store.state.getundone) {
        this.getundone();
      }
    }
    // 获取历史地址记录
    if (!this.isNeedLogin() && !__getItem('history')) {
      this.getHistory();
    } else {
      var historyList = JSON.parse(__getItem('history'));
      if (historyList && historyList.length > 0) {
        this.history = {
          address: historyList[0].address,
          detDdress: historyList[0].detDdress,
          lat: historyList[0].lat,
          lng: historyList[0].lng,
        }
      }
    }
    __setItem('nowIndex', this.nowIndex);
    var map = new AMap.Map('container', {
      resizeEnable: true
    });
    // AMap.event.addDomListener(document.getElementById('pantoBtn'), 'click', () => {
    //   let addresName = __getItem('addresName') ? JSON.parse(__getItem('addresName')) : {lng:116.397428, lat:39.90923};
    //   map.panTo([addresName.lng,addresName.lat]);
    // });
    if (this.$store.state.isRelocation) {
      this.accurate(); // 精准定位
      if(__isWeChat()){
        this.wxGetLocationLngLat();
      }
    } else {
      let departure = JSON.parse(__getItem('addresName'));

      if (!departure) {
        this.accurate();
      } else {
        var map = new AMap.Map('container', {
          center: [departure.lng, departure.lat],
          resizeEnable: true,
          zoom: 16
        });
        var marker = new AMap.Marker({
          map: map,
          position: [departure.lng, departure.lat],
          content:`<img src=${require("../../assets/new/position.png")} style="width:22px;height:32px"/>`,
          offset: new AMap.Pixel(-36, -13),
          autoRotation: true,
          angle: 0
        });
        marker.setMap(map);
        this.getNearbyCar(map, departure);
      }
    }
    this.locationCity(); // 定位城市


    // 出发地
    if (this.$route.query.addresName) {
      let departure = this.$route.query.addresName;
      this.child.addresName = {
        name: departure.name,
        lat: departure.lat,
        lng: departure.lng,
        depAddress: departure.district,
      }
      __setItem('addresName', this.child.addresName);
      this.departure(departure);
    } else {
      let departure = JSON.parse(__getItem('addresName'))
      if (departure) {
        this.child.addresName = {
          name: departure.name,
          lat: departure.lat,
          lng: departure.lng,
          depAddress: departure.district,
        }
      }
    }
    // 目的地
    if (this.$route.query.backAddresname) {
      let arrival = this.$route.query.backAddresname;
      if (arrival === null) return false;
      this.child.backAddresname = {
        name: arrival.name,
        lat: arrival.lat,
        lng: arrival.lng,
        arrAddress: arrival.district,
      }
      __setItem('backAddresname', this.child.backAddresname);
    } else {
      let arrival = JSON.parse(__getItem('backAddresname'));
      if (arrival) {
        this.child.backAddresname = {
          name: arrival.name,
          lat: arrival.lat,
          lng: arrival.lng,
          arrAddress: arrival.arrAddress,
        }
      }
    }
  },
  created() {
    if (window.location.href.indexOf('?#') < 0) {
      window.location.href = window.location.href.replace('#', '?#')
    }
  },
  methods: {
    // 重新定位
    positionRight() {
      this.$store.commit('arriveName', {});
      this.child.backAddresname = {};
      __removeItem('backAddresname');
      var map = new AMap.Map('container', {
        resizeEnable: true
      });
      AMap.plugin(["AMap.Geolocation"], () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          extensions: "all",  // 返回详细定位信息
          timeout: 1000,          //超过10秒后停止定位，默认：5s
          buttonPosition:'RB',    //定位按钮的停靠位置
          showButton: false,
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
          markerOptions:{//自定义定位点样式，同Marker的Options
            offset: new AMap.Pixel(-18, -36),
            content:`<img src=${require("../../assets/new/position.png")} style="width:22px;height:32px"/>`
          },
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "error", obj => {
          Toast('获取定位失败');
        });
        AMap.event.addListener(geolocation, "complete", obj => {
          this.child.addresName.name = obj.aois[0].name;
          this.child.addresName.lat = obj.position.lat;
          this.child.addresName.lng = obj.position.lng;
          this.child.addresName.depAddress = obj.formattedAddress;
          __setItem('addresName', this.child.addresName);
          let departure = {
            lat: obj.position.lat,
            lng: obj.position.lng,
          };
          // 定位出发地
          this.departure(departure);
          this.getNearbyCar(map, departure)
        });
      });
    },
    // 单点登录未登录跳登录页
    noLoginToLoginPage(type) {
      if(!__getItem('urlIsBack')){
        const href = window.location.origin + '/car/#/';
        const URI = encodeURIComponent(`${href}?${type === 'train' ? 'channel=train' : 'type=trip' }&back=1`);
        window.location.href = `https://www.dajiashequ.com/yuetucompany/joinAndRegisterCompany.action?companyID=892485852779041661148774&callBackUrl=${URI}`;
      }
    },
    // 单点登录
    defaultLogin(type, urlObj={},openID='') {
      this.$axios
        .post("/autologin", {
          username: urlObj.username ? urlObj.username : '',
          name: urlObj.name ? urlObj.name : '',
          openId: openID
        })
        .then(response => {

          if(response.data.code !== 200) {
            this.noLoginToLoginPage(type);
          } else if (response.data.code === 200 && response.data.data) {
            // 当前用车的人 - 初始值为登录用户
            localStorage.setItem('currentUseCarUser', JSON.stringify(
              {
                'name': response.data.data.name,
                'phone': response.data.data.username,
              }
            ))
            // 存储所有登录过的用户
            const userData = {
              'userID': response.data.data.username,
              'name': response.data.data.name,
              'phone': response.data.data.username,
              'users': [
                {
                  'name': response.data.data.name,
                  'phone': response.data.data.username,
                  'userID': response.data.data.username,
                }
              ]
            }
            let usersAllData = localStorage.getItem('usersAllData') ? JSON.parse(localStorage.getItem('usersAllData')) : [];
            if(usersAllData.length > 0) {
              let index = 0;
              usersAllData.forEach(user => {
                if(user.phone === response.data.data.username) {
                  index += 1;
                }
              })
              if(index === 0) usersAllData.push(userData);
            } else {
              usersAllData.push(userData)
            }
            localStorage.setItem('usersAllData', JSON.stringify(usersAllData));

            const { token, username, name } = response.data.data;
            __setLocalItem("auth", token);
            if(!__getLocalItem('name')) {
              __setLocalItem("name", name || '');
            }
            if(!__getLocalItem('phone')) {
              __setLocalItem("phone", username || '');
            }
            this.riderInfo.name = __getLocalItem('name') ? __getLocalItem('name') : name;
            this.riderInfo.phone = __getLocalItem('phone') ? __getLocalItem('phone') : username;
          }
        })
        .catch(function(err) {
          this.noLoginToLoginPage(type);
        });
    },
    // 获取历史地址记录
    getHistory() {
      this.$axios.get("/loc/history").then(res => {
        if (res.data.code === 200 && res.data.data) {
          if (res.data.data.length > 0) {
            this.history = {
              address: res.data.data[0].address,
              detDdress: res.data.data[0].detDdress,
              lat: res.data.data[0].lat,
              lng: res.data.data[0].lng,
            }
            __setItem("history", res.data.data);
          }
        }
      });
    },
    // 出发地定位点
    departure(departure) {
      var map = new AMap.Map('container', {
        center: [departure.lng, departure.lat],
        resizeEnable: true,
        zoom: 13
      });
      var marker = new AMap.Marker({
        map: map,
        position: [departure.lng, departure.lat],
        content:`<img src=${require("../../assets/new/position.png")} style="width:22px;height:32px"/>`,
        offset: new AMap.Pixel(-36, -13),
        autoRotation: true,
        angle: 0
      });
      marker.setMap(map);
      this.getNearbyCar(map, departure);
    },
    // 获取附近车辆
    getNearbyCar(map, departure) {
      this.$axios.get('/loc/nearbydrivers', {
        lat: departure.lat,
        lng: departure.lng,
      }).then((res) => {
        if (res.data.code === 200 && res.data.data) {
          var capitals = res.data.data;
          var startIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(17, 32),
              // 图标的取图地址
              image: require('../../assets/map_car.png'),
              // 图标所用图片大小
              imageSize: new AMap.Size(17, 32),
          });
          var facilities = [];
          for (var i = 0; i < capitals.length; i++) {
              var marker = new AMap.Marker({
                  position: new AMap.LngLat(capitals[i].lng, capitals[i].lat),
                  offset: new AMap.Pixel(-10, -10),
                  icon: startIcon,
              });
              facilities.push(marker);
          }
          map.add(facilities);
        } else {
          Toast('获取附近车辆失败')
        }
      })
    },
    // 绘制路线
    drivingMap() {
      var map = new AMap.Map('container', {
        resizeEnable: true,
      });
      // 创建起点终点路线
      var driving;
      AMap.plugin(["AMap.Driving"], () => {
        const drivingOption = {
          policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
          ferry: 1, // 是否可以使用轮渡
          map: map,
          hideMarkers: false, // 设置隐藏路径规划的起始点图标
          autoFitView: true
        };
        driving = new AMap.Driving(drivingOption); // 构造驾车导航类
      });
      let departure = JSON.parse(__getItem('addresName'));
      let arrival = JSON.parse(__getItem('backAddresname'));
      // 根据起终点坐标规划驾车路线
      driving.search(new AMap.LngLat(departure.lng,departure.lat), new AMap.LngLat(arrival.lng,arrival.lat), (status, result) => {
        if (status === 'complete') {
          map.setFitView();
          var time = new Date().getTime() + (result.routes[0].time * 1000);
          var hours = new Date(time).getHours();
          var minutes = new Date(time).getMinutes();
          var distance = Math.floor(result.routes[0].distance/1000).toFixed(1);
          var timeMinutes = Math.floor(result.routes[0].time/60);

          var lnglat = new AMap.LngLat(arrival.lng,arrival.lat);

          // <div style="padding: 5px 0;font-size: 14px;">预计<span style="color:#25A3FF;">${hours}:${minutes}</span>到达</div>
          var infoWindowContent =`<div>
                                    <div style="padding: 5px 0;">全程<span style="color:#25A3FF;">${distance}公里</span>,约行驶<span style="color:#25A3FF;">${timeMinutes}分钟</span></div>
                                  </div>`;
          var infoWindowContentNowTime =`<div>
                                    <div style="padding: 5px 0;">全程<span style="color:#25A3FF;">${distance}公里</span></div>
                                  </div>`;
          var infoWindow = new AMap.InfoWindow({
            position: lnglat,
            offset: new AMap.Pixel(0, -35),
            content: this.$store.state.nowIndex === 0 ? infoWindowContent : infoWindowContentNowTime
          });
          infoWindow.open(map);
          // 起点位置 marker
          var marker = new AMap.Marker({
            map: map,
            position: [departure.lng, departure.lat],
            content:`<div style="width: 80px;
                      background-color: #fff;
                      border-radius: 50px;
                      padding: 3px;">参考路线</div>`,
            offset: new AMap.Pixel(-40, 10),
            autoRotation: true,
          });
          marker.setMap(map);

          var currentZoom = map.getZoom();
          map.setZoom(currentZoom-1);
        } else {
          console.log('获取驾车数据失败：' + result)
        }
      });
    },
    getpush(_url) {
      if (this.isNeedLogin()) return this.$router.push({ name: "Login" });
      if (this.isNeedName()) return this.$router.push({ name: "LoginName" });
      this.$router.push({ name: _url });
    },
    accurate() {
      var map = new AMap.Map('container', {
        resizeEnable: true
      });
      AMap.plugin(["AMap.Geolocation"], () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          extensions: "all",  // 返回详细定位信息
          timeout: 1000,          //超过10秒后停止定位，默认：5s
          buttonPosition:'RB',    //定位按钮的停靠位置
          showButton: false,
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
          markerOptions:{//自定义定位点样式，同Marker的Options
      		  offset: new AMap.Pixel(-18, -36),
      		  content:`<img src=${require("../../assets/new/position.png")} style="width:22px;height:32px"/>`
      		},
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "error", obj => {
          // console.log('获取定位失败', obj)
          if(!__isWeChat()) {
            Toast('获取定位失败');
          }
        });
        AMap.event.addListener(geolocation, "complete", obj => {
          this.child.addresName.name = obj.aois[0].name;
          this.child.addresName.lat = obj.position.lat;
          this.child.addresName.lng = obj.position.lng;
          this.child.addresName.depAddress = obj.formattedAddress;
          __setItem('addresName', this.child.addresName);
          let departure = {
            lat: obj.position.lat,
            lng: obj.position.lng,
          };
          this.getNearbyCar(map, departure)
        });
      });
    },
    locationCity() {
      AMap.plugin(["AMap.CitySearch"], () => {
        const citysearch = new AMap.CitySearch({});
        citysearch.getLocalCity( (status, result) => {
          if (status === "complete" && result.info === "OK") {
            if (result && result.city && result.bounds) {
              this.$store.commit("city", result.city)
              __setItem("city", result.city)
            }
          }
        });
      });
    },
    // 微信环境获取定位信息
    wxGetLocationLngLat() {
      const that = this;
      that.$axios.post("/wx/jssdk/authorization", {
        wapUrl: window.location.href.split('#')[0]
      })
        .then(ress => {
          if(ress.data.code === 200) {
            const resData = ress.data.data;
            wx.config({
              debug: false,
              appId: 'wx63cc31048451111b', // 必填，公众号的唯一标识
              timestamp: resData.timestamp, // 必填，生成签名的时间戳
              nonceStr: resData.noncestr, // 必填，生成签名的随机串
              signature: resData.sign,// 必填，签名
              jsApiList: ['getLocation']
            })
            wx.ready(function(){
              wx.getLocation({
                // type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                  const params = {
                    lat: res.latitude, // 纬度，浮点数，范围为90 ~ -90
                    lng: res.longitude // 经度，浮点数，范围为180 ~ -180。
                  }
                  // 根据微信获取的经纬度，从后端获取挡墙的详细地址
                  that.getAdressDetail(params);
                }
              });
            })
            wx.error(function(error){
              console.log('微信获取地址信息失败');
            });
          } else {
            Toast(ress.data.msg);
          }
        })
        .catch(err => {
          console.log('微信获取地址信息失败');
        })
    },
    // 根据微信获取的经纬度，从后端获取挡墙的详细地址
    getAdressDetail(params) {
      const that = this;
      that.$axios.get('/loc/address?' + _getobj(params)).then(res => {
        if(res.data.code === 200) {
          const data = res.data.data;
          if(__getItem('addresName')) {
            return false;
          }
          this.child.addresName.name = data.address;
          this.child.addresName.lat = data.lat;
          this.child.addresName.lng = data.lng;
          this.child.addresName.depAddress = data.formattedAddress;
          __setItem('addresName', this.child.addresName);
          let departure = {
            lat: data.lat,
            lng: data.lng,
          };
          // 定位出发地
          this.departure(departure);
        }
      })
    },
    activeTabs(index) {
      this.nowIndex = index;
      if (index === 0) {
        this.child.selectDate = '现在出发';
        __setItem('nowIndex', 0);
        this.$store.commit("nowIndex", 0);
      } else {
        // this.child.selectDate = __getItem('getNewTime')? __getItem('getNewTime') :'选择时间';
        this.child.selectDate = '选择时间';
        __setItem('nowIndex', 1);
        this.$store.commit("nowIndex", 1);
      }
      let departure = JSON.parse(__getItem('addresName'));
      let arrival = JSON.parse(__getItem('backAddresname'));
      if (departure && arrival) {
        this.drivingMap();
      }
    },
    // 判断用户是否登录
    isNeedLogin() {
      let needLogin = true;
      if (__getLocalItem("auth") !== "" && __getLocalItem("auth") !== null) {
        needLogin = false;
      }
      return needLogin;
    },
    // 弹窗点击我知道了关闭弹窗
    ievent() {
      this.DialogVisible = false;
    },
    // 判断订单弹窗
    getundone() {
      this.$axios.get("/travel/undone").then(res => {
        if (res.data.code === 200) {
          if (res.data.data.length > 0) {
            this.DialogVisible = true;
            this.orderlength = res.data.data.length;
            this.orderId = res.data.data[0].tno;
          }
        }
      });
    },
    // SSE监测用户订单状态
    watchUserRouteState() {
      var url = process.env.API_ROOT + "/travel/geo/1234";
      let headers = {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        auth: __getLocalItem("auth")
      };
      var eventSourceInitDict = { headers: headers };
      this.eventSource = new EventSource(url, eventSourceInitDict);
      this.eventSource.addEventListener("TravelGeo", e => {
        console.log(e.data);
      });
    },
    // 删除SSE监测
    closeSSE() {
      if (this.eventSource !== null) {
        this.eventSource.close(); // 关闭
        this.eventSource.removeAllListeners("TravelGeo"); // 删除
      }
    },
    // 判断是否有用户名
    isNeedName() {
      let isNeedName = true;
      if (__getLocalItem("name") !== "" && __getLocalItem("name") !== null) {
        isNeedName = false;
      }
      return isNeedName;
    },
    goback() {
      this.carSelection = false;
    },
    clickTag() {
      let arrival = this.history;
      if (arrival) {
        this.child.backAddresname = {
          name: arrival.address,
          lat: arrival.lat,
          lng: arrival.lng,
          arrAddress: arrival.detDdress,
        }
        __setItem('backAddresname', this.child.backAddresname);
      }
    },
    isLogin(type) { // 是否登录 type 0为个人中心 1 为出发地 2为目的地 3 时间 4位乘车人 5 是立即用车
      this.$store.commit('scroll', false);
      if (this.isNeedLogin()) return this.$router.push({ name: "Login" });
      if (this.isNeedName()) return this.$router.push({ name: "LoginName" });
      if (type === 1) {
        this.go();
        this.$router.push({ name: "Addres" });
      } else if (type === 2) {
        this.back();
        this.$router.push({ name: "Addres" });
      } else if (type === 3) {
        this.showTimePicker = true;
      } else if (type === 4) {
        this.$router.push({
          path: "BusUsers",
          query: {
            busUserName: this.riderInfo.name,
            busUserPhone: this.riderInfo.phone
          }
        });
      } else if (type === 0) {
        this.showMask = true;
      }
    },
    clickDeleteTag() {
      this.deleteTag = false;
    },
    rightOff() {
      if(!this.child.addresName.name) return Toast("请选择出发地");
      if(!this.child.backAddresname.name) return Toast("请选择目的地");
      if(this.child.selectDate === '选择时间') return Toast("请选择出发时间");
      if (__getItem('nowIndex') === '0') {
        this.$store.commit("nowIndex", 0);
      } else {
        this.$store.commit("nowIndex", 1);
      }
      this.$refs.child.generatePrice();
      this.show = true;
      setTimeout( () => {
        this.show = false;
        this.carSelection = true;
      }, 2000)
    },
    nowTime(nowTime) {
      this.child.selectDate = nowTime;
      this.$store.commit('selectDate', nowTime);
      if (nowTime === '现在出发') {
        this.activeTabs(0)
      }
      this.showTimePicker = false;
    },
    go() {
      this.$store.commit("go", true);
    },
    back() {
      this.$store.commit("back", false);
    },
  }
}
</script>
<style>
  .amap-info-close {
    display: none!important;
  }
  .amap-info-content {
    padding: 0 18px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.12);
    border-radius: 50px;
    text-align: center;
  }
  /* #main{
    width: 100%;
    height: 10%;
    position: absolute;
    top: 90%;
    left: 0;
    z-index: 5555;
    background: white;
  } */
</style>
<style lang="scss" scoped>
  .wrap {
    width: 100%;
    height: 100vh;
    .home {
      width: 100%;
      height: 100vh;
      #container {
        width: 100%;
        height: 70vh;
        position: absolute;
        top: 0;
      }
      .model {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #000000;
        z-index: 11111;
        opacity: 0.6;
      }
      .goback {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 36px;
        height: 36px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .main {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: #fff;
        box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.1);
        border-radius:10px 10px 0px 0px;
        z-index: 111;
        .userInfo {
          position: absolute;
          top: -50px;
          width: 36px;
          height: 36px;
          .img {
            width: 100%;
          }
        }
        .positionLeft {
          left: 15px;
        }
        .positionRight {
          right: 15px;
        }
        .nav {
          height: 22px;
          line-height: 22px;
          display: flex;
          padding: 25px 25px 10px;
          li {
            color: #555555;
            font-size: 15px;
            font-family: PingFang-SC-Bold,PingFang-SC;
            font-weight:bold;
            margin-right: 20px;
          }
          .active {
            color: #222222;
            font-size:22px;
            font-family: PingFang-SC-Heavy,PingFang-SC;
            font-weight:800;
            margin-bottom: -3px;
            border-bottom: 8px solid #97D3FF;
          }
        }
        .content {
          .addres{
            width: 100%;
            background-color: #fff;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            position: relative;
            .arrImg {
              display: inline-block;
              width: 6px;
              height: 6px;
              img {
                width: 100%;
                margin-bottom: 3px;
              }
            }
            .goAddres {
              width: 80%;
              height: 50px;
              display: inline-block;
              padding: 0 3%;
              line-height: 50px;
              text-align: left;
              border-bottom: 1px solid #EDEDED;
              border-top: 0;
              border-left: 0;
              border-right: 0;
            }
            ::-webkit-input-placeholder {
              font-size: 16px;
              font-family: PingFang-SC-Bold,PingFang-SC;
              font-weight: bold;
              color: rgba(204,204,204,1);
            }
            .tag {
              position: absolute;
              right: 30px;
              top: 7px;
              width: 148px;
              height: 36px;
              line-height: 36px;
              display: flex;
              background-color: #706F7F;
              border-radius: 2px;
              span {
                padding-left: 10px;
                text-align: left;
                font-size:13px;
                font-family:PingFang-SC-Medium,PingFang-SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                width: 100px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .img {
                position: absolute;
                right: 30px;
                width: 8px;
                height: 8px;
                img {
                  width: 100%;
                  height: 100%;
                  padding: 14px;
                }
              }
            }
            .tag:after {
              position: absolute;
              left: -15px;
              top: 3px;
              content: "";
              width: 0;
              height: 0;
              border-left: 5px solid transparent;
              border-top: 15px solid transparent;
              border-right: 15px solid #706F7F;
              border-bottom: 15px solid transparent;
            }
          }
          .ridingInfo {
            margin: 10px 20px 15px;
            height:55px;
            background-color: #fff;
            box-shadow:0px 2px 8px 0px rgba(0,0,0,0.08);
            border-radius:4px;
            .styleA {
              color: #999999;
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              .titleImg {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 17px;
                .timemsg {
                  width: 15px;
                  height: 15px;
                  margin-right: 7px;
                }
              }
            }
            .center-line {
              line-height: 50px;
              color: #999;
            }
          }
        }
        .right-off {
          margin: 20px;
          height: 55px;
          line-height: 55px;
          text-align: center;
          background: rgba(37,163,255,1);
          border-radius: 4px;
          font-size: 16px;
          font-family:PingFang-SC-Bold,PingFang-SC;
          font-weight:bold;
          color: #fff;
          letter-spacing: 1px;
        }
      }
    }
  }
</style>
<style>
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-leave-to,
  .slide-fade-enter {
    transform: translateX(-286px);
    opacity: 0;
  }
  .pull-up-enter-active {
    transition: all 0.3s ease;
  }
  .pull-up-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .pull-up-leave-to,
  .pull-up-enter {
    transform: translateY(100px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/home.vue